export type SourceProduct = {
  brand: string;
  model: string;
  productGroup: string;
  isAvailable: boolean;
  price: {
    amount: number;
    currency: string;
    date: string;
  };
  testProgram: string;
  publicationDate: string;
  image: string;
  detailUrl: string;
};

export type Product = {
  name: string;
  brand: string;
  category: string;
  isAvailable: boolean;
  price: number;
  currency: string;
  priceDate: string;
  testProgram: string;
  publicationDate: string;
  image: string;
  detailUrl: string;
  overall: number;
  handling: number;
  safety: number;
};

export type SortOption = "overall-asc" | "overall-desc" | "price-asc" | "price-desc";

export type UiState = {
  category: string;
  maxOverall: string;
  sortBy: SortOption;
};

export const DEFAULT_STATE: UiState = {
  category: "Alle",
  maxOverall: "5",
  sortBy: "overall-asc"
};

export const MAX_OVERALL_VALUES = ["5", "3", "2.5", "2"] as const;
